import { useStore } from '@/lib/store'
import { dismissToast as dismiss, toasts } from '@/lib/toast'
import { CheckCircle2, AlertTriangle, Info, X } from 'lucide-react'
import { cn } from '@/lib/utils'

const icons = { success: CheckCircle2, error: AlertTriangle, info: Info }

export function Toaster() {
  const list = useStore(toasts)
  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-[calc(5rem+env(safe-area-inset-bottom))] z-[60] flex flex-col items-center gap-2 px-4 md:bottom-6 md:items-end"
    >
      {list.map((t) => {
        const Icon = icons[t.tone]
        return (
          <div
            key={t.id}
            role={t.tone === 'error' ? 'alert' : 'status'}
            className="glass pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl px-4 py-3 text-sm shadow-soft animate-rise"
          >
            <Icon
              className={cn(
                'mt-0.5 size-4 shrink-0',
                t.tone === 'success' && 'text-success',
                t.tone === 'error' && 'text-destructive',
                t.tone === 'info' && 'text-primary',
              )}
            />
            <span className="flex-1">{t.message}</span>
            <button onClick={() => dismiss(t.id)} className="-m-1 rounded p-1 text-muted-foreground hover:text-foreground">
              <X className="size-3.5" />
              <span className="sr-only">Dismiss</span>
            </button>
          </div>
        )
      })}
    </div>
  )
}
